import { Input, InputGroup, InputGroupText } from "reactstrap";
import SapIcon from "./SapIcon";
import { useState } from "react";

interface Props {
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
}

export default function HiddenTextInput({ value, onChange, disabled }: Props) {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <InputGroup>
            <Input
                type={showPassword ? "text" : "password"}
                value={value}
                onChange={(e) => onChange && onChange(e.target.value)}
                disabled={disabled}
                style={{ paddingRight: "40px" }}
            />
            <InputGroupText
                style={{
                    cursor: "pointer",
                    background: "transparent",
                    border: "none",
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 10,
                    padding: "0",
                    width: "auto",
                }}
                onClick={() => setShowPassword(!showPassword)}
            >
                {
                    <SapIcon
                        size="sm"
                        icon={showPassword ? "eye-slash" : "eye"}
                        className={showPassword ? "" : "text-muted"}
                    />
                }
            </InputGroupText>
        </InputGroup>
    );
}
